import React from 'react'

import MainNav from '../Nav/MainNav'
import VeryTop from '../Nav/VeryTop'
import logo from "../../assets/images/logo.svg"

import "../../assets/styles/layout/header.scss"

export default function Header() {
  return (
    <div className="header">
      <div className="very-top">
        <div className="container">
          <VeryTop />
        </div>
      </div>
      <div className="container">
        <div className="wrapper">
          <img className="logo" alt="ShatterProof" src={logo} />
          <MainNav />
        </div>
      </div>
    </div>
  )
}
